export default __webpack_public_path__ + "static/media/Avax-icon.73b3f250.png";